import { useMemo, useState } from 'react'
import { errorHandler } from '../../../../services/util/error.service'
import * as EnvioHttp from '../../../../services/api/https/deliveries/envio-rota.http'
import { convertToFormatedDateString, getPeriodoFromLastXDays } from '../../../../services/util/date.service'
import {
  urlReportMapaDeCargaAnalitico,
  urlReportMapaDeCargaAnaliticoAgrupado,
  urlReportMapaDeCargaAnaliticoProdutoEmpresa,
  urlReportMapaDeCargaAnaliticoEmpresaCidade,
  urlReportMapaDeCargaAnaliticoGrupoEEmpresa,
} from '../../../../services/api/routes/deliveries.routes'
import { gerarArquivoExcel } from '../../../../services/util/excel.service'
import { getUsuarioInfo } from '../../../../services/localstorage/localstorage.service'

const { pInicial: defaultPInicial, pFinal: defaultPFinal } = getPeriodoFromLastXDays(31, 7)

const INITIAL_STATE = {
  errorMessage: null,
  successMessage: null,
  loadingMessage: null,
  fleets: [],
  selectedDataPrevista: null,
  expectedDates: [],
  selectedFleet: null,
  globalFilter: '',
  selecionarTodos: false,
  periodo: { dataInicial: defaultPInicial, dataFinal: defaultPFinal },
}

export default function useMapaCargaAnalitico(initialPeriodo = INITIAL_STATE.periodo) {
  const [state, setState] = useState({
    ...INITIAL_STATE,
    periodo: initialPeriodo || INITIAL_STATE.periodo,
  })

  const localDispatch = useMemo(() => {
    const getExpectedDateArray = fleets => {
      return Array.from(new Set(fleets.map(f => convertToFormatedDateString(f.expected_date))))
    }

    return {
      async fetchVeiculosParaEmissaoMapaCarga(selectedTp, pInicial, pFinal) {
        try {
          const { id: user_id } = getUsuarioInfo()
          const { fleets } = await EnvioHttp.getFrotasParaEnvio(selectedTp, user_id, pInicial, pFinal)
          const dates = getExpectedDateArray(fleets).map(d => ({ value: d, label: d }))
          setState(prev => ({
            ...prev,
            loadingMessage: null,
            fleets,
            expectedDates: dates,
          }))
        } catch (e) {
          setState(prev => ({ ...prev, errorMessage: errorHandler(e), loadingMessage: null }))
        }
      },

      onPesquisar(selectedTp, pInicial, pFinal) {
        setState(prev => ({ ...prev, periodo: { dataInicial: pInicial, dataFinal: pFinal } }))
        localDispatch.fetchVeiculosParaEmissaoMapaCarga(selectedTp, pInicial, pFinal)
      },

      resetState() {
        setState(prev => ({
          ...prev,
          loadingMessage: null,
          errorMessage: null,
          successMessage: null,
        }))
      },

      // Events
      onBtnEmitirMapaClick(fleetsSelected, selectedTp) {
        if (!Array.isArray(fleetsSelected) || fleetsSelected.length === 0) {
          setState(prev => ({ ...prev, errorMessage: 'Nenhuma placa foi selecionada' }))
        } else {
          const invalidFleets = fleetsSelected.filter(
            f => !f.deliveries || f.deliveries.length === 0,
          )
          if (invalidFleets.length > 0) {
            const labels = invalidFleets
              .map(f => `${convertToFormatedDateString(f.expected_date)} - ${f.vehicle_badge}`)
              .join(' , ')
            setState(prev => ({
              ...prev,
              errorMessage: `Não é possível gerar o relatório pois o usuário não tem acesso à todas as empresas associadas ao(s) veículo(s): ${labels}`,
            }))
            return
          }
          const url = urlReportMapaDeCargaAnalitico(
            selectedTp,
            fleetsSelected.map(f => f.fleet_id).join(','),
          )
          window.open(url, '_blank')
          setTimeout(() => {
            setState(prev => {
              localDispatch.fetchVeiculosParaEmissaoMapaCarga(selectedTp, prev.periodo.dataInicial, prev.periodo.dataFinal)
              return prev
            })
          }, 2000)
        }
      },

      onBtnEmitirMapaAgrupadoClick(fleetsSelected, selectedTp) {
        if (!Array.isArray(fleetsSelected) || fleetsSelected.length === 0) {
          setState(prev => ({ ...prev, errorMessage: 'Nenhuma placa foi selecionada' }))
        } else {
          const invalidFleets = fleetsSelected.filter(
            f => !f.deliveries || f.deliveries.length === 0,
          )
          if (invalidFleets.length > 0) {
            const labels = invalidFleets
              .map(f => `${convertToFormatedDateString(f.expected_date)} - ${f.vehicle_badge}`)
              .join(' , ')
            setState(prev => ({
              ...prev,
              errorMessage: `Não é possível gerar o relatório pois o usuário não tem acesso à todas as empresas associadas ao(s) veículo(s): ${labels}`,
            }))
            return
          }
          const url = urlReportMapaDeCargaAnaliticoAgrupado(
            selectedTp,
            fleetsSelected.map(f => f.fleet_id).join(','),
          )
          window.open(url, '_blank')
          setTimeout(() => {
            setState(prev => {
              localDispatch.fetchVeiculosParaEmissaoMapaCarga(selectedTp, prev.periodo.dataInicial, prev.periodo.dataFinal)
              return prev
            })
          }, 2000)
        }
      },

      onBtnEmitirMapaCargaProdutoEmpresaClick(fleetsSelected, selectedTp) {
        if (!Array.isArray(fleetsSelected) || fleetsSelected.length === 0) {
          setState(prev => ({ ...prev, errorMessage: 'Nenhuma placa foi selecionada' }))
        } else {
          const invalidFleets = fleetsSelected.filter(
            f => !f.deliveries || f.deliveries.length === 0,
          )
          if (invalidFleets.length > 0) {
            const labels = invalidFleets
              .map(f => `${convertToFormatedDateString(f.expected_date)} - ${f.vehicle_badge}`)
              .join(' , ')
            setState(prev => ({
              ...prev,
              errorMessage: `Não é possível gerar o relatório pois o usuário não tem acesso à todas as empresas associadas ao(s) veículo(s): ${labels}`,
            }))
            return
          }
          const url = urlReportMapaDeCargaAnaliticoProdutoEmpresa(
            selectedTp,
            fleetsSelected.map(f => f.fleet_id).join(','),
          )
          window.open(url, '_blank')
          setTimeout(() => {
            setState(prev => {
              localDispatch.fetchVeiculosParaEmissaoMapaCarga(selectedTp, prev.periodo.dataInicial, prev.periodo.dataFinal)
              return prev
            })
          }, 2000)
        }
      },

      onBtnEmitirMapaCargaEmpresaCidadeClick(fleetsSelected, selectedTp) {
        if (!Array.isArray(fleetsSelected) || fleetsSelected.length === 0) {
          setState(prev => ({ ...prev, errorMessage: 'Nenhuma placa foi selecionada' }))
        } else {
          const invalidFleets = fleetsSelected.filter(
            f => !f.deliveries || f.deliveries.length === 0,
          )
          if (invalidFleets.length > 0) {
            const labels = invalidFleets
              .map(f => `${convertToFormatedDateString(f.expected_date)} - ${f.vehicle_badge}`)
              .join(' , ')
            setState(prev => ({
              ...prev,
              errorMessage: `Não é possível gerar o relatório pois o usuário não tem acesso à todas as empresas associadas ao(s) veículo(s): ${labels}`,
            }))
            return
          }
          const url = urlReportMapaDeCargaAnaliticoEmpresaCidade(
            selectedTp,
            fleetsSelected.map(f => f.fleet_id).join(','),
          )
          window.open(url, '_blank')
          setTimeout(() => {
            setState(prev => {
              localDispatch.fetchVeiculosParaEmissaoMapaCarga(selectedTp, prev.periodo.dataInicial, prev.periodo.dataFinal)
              return prev
            })
          }, 2000)
        }
      },

      onBtnEmitirMapaCargaGrupoEEmpresaClick(fleetsSelected, selectedTp) {
        if (!Array.isArray(fleetsSelected) || fleetsSelected.length === 0) {
          setState(prev => ({ ...prev, errorMessage: 'Nenhuma placa foi selecionada' }))
        } else {
          const invalidFleets = fleetsSelected.filter(
            f => !f.deliveries || f.deliveries.length === 0,
          )
          if (invalidFleets.length > 0) {
            const labels = invalidFleets
              .map(f => `${convertToFormatedDateString(f.expected_date)} - ${f.vehicle_badge}`)
              .join(' , ')
            setState(prev => ({
              ...prev,
              errorMessage: `Não é possível gerar o relatório pois o usuário não tem acesso à todas as empresas associadas ao(s) veículo(s): ${labels}`,
            }))
            return
          }
          const url = urlReportMapaDeCargaAnaliticoGrupoEEmpresa(
            selectedTp,
            fleetsSelected.map(f => f.fleet_id).join(','),
          )
          window.open(url, '_blank')
          setTimeout(() => {
            setState(prev => {
              localDispatch.fetchVeiculosParaEmissaoMapaCarga(selectedTp, prev.periodo.dataInicial, prev.periodo.dataFinal)
              return prev
            })
          }, 2000)
        }
      },

      async onBtnCancelarMapaEmitidoClick(fleetsSelected, selectedTp) {
        if (!Array.isArray(fleetsSelected) || fleetsSelected.length === 0) {
          return setState(prev => ({ ...prev, errorMessage: 'Nenhuma placa foi selecionada' }))
        }

        setState(prev => ({ ...prev, loadingMessage: 'Cancelando mapa de carga' }))

        try {
          await EnvioHttp.cancelarMapaEmitido(fleetsSelected.map(f => f.fleet_id).join(','))
          setState(prev => ({
            ...prev,
            loadingMessage: null,
            successMessage: 'Mapa(s) de Carga cancelado(s) com sucesso',
          }))
          setState(prev => {
            localDispatch.fetchVeiculosParaEmissaoMapaCarga(selectedTp, prev.periodo.dataInicial, prev.periodo.dataFinal)
            return prev
          })
        } catch (e) {
          setState(prev => ({ ...prev, loadingMessage: null, errorMessage: errorHandler(e) }))
        }
      },

      onBtnLimparFiltroClick() {
        setState(prev => {
          prev.selectedDataPrevista = ''
          prev.fleets.forEach(f => (f.selected = false))
          return { ...prev }
        })
      },

      onCmbDataPrevistaChange(expected_date) {
        setState(prev => {
          const { fleets } = prev
          fleets.forEach(f => {
            f.selected = convertToFormatedDateString(f.expected_date) === expected_date
          })
          return { ...prev, selectedDataPrevista: expected_date }
        })
      },

      onItemClicked(fleet) {
        setState(prev => {
          const { fleets } = prev
          const index = fleets.findIndex(f => f.fleet_id === fleet.fleet_id)
          if (index !== -1) {
            fleets[index].selected = !fleets[index].selected
          }
          return { ...prev }
        })
      },

      onMenuItemClick(item, fleet) {
        if (item !== 'Ordem Carregamento') return
        if (!fleet.deliveries || fleet.deliveries.length === 0) {
          setState(prevState => ({
            ...prevState,
            errorMessage: 'Usuário não tem acesso a todas as empresas associadas a rota',
          }))
          return
        }
        setState(prevState => ({ ...prevState, selectedFleet: fleet }))
      },

      onModalResponse(action, payload) {
        if (action === 'close') {
          setState(prevState => ({ ...prevState, selectedFleet: null }))
        } else if (action === 'error') {
          setState(prevState => ({ ...prevState, errorMessage: payload }))
        } else if (action === 'success') {
          setState(prevState => {
            const index = prevState.fleets.findIndex(
              f => f.fleet_id === prevState.selectedFleet.fleet_id,
            )
            if (index !== -1) {
              prevState.fleets[index].deliveries = payload
            }
            return { ...prevState, selectedFleet: null }
          })
        }
      },

      onGlobalFilterChange(value) {
        setState(prev => ({ ...prev, globalFilter: value }))
      },

      onBtnExportarExcelClick(fleets) {
        const fleetsSelected = fleets.filter(f => f.selected)

        if (fleetsSelected.length === 0) {
          setState(prev => ({ ...prev, errorMessage: 'Nenhum veículo selecionado' }))
          return
        }

        const invalidFleets = fleetsSelected.filter(f => !f.deliveries || f.deliveries.length === 0)
        if (invalidFleets.length > 0) {
          const labels = invalidFleets
            .map(f => `${convertToFormatedDateString(f.expected_date)} - ${f.vehicle_badge}`)
            .join(' , ')
          setState(prev => ({
            ...prev,
            errorMessage: `Não é possível gerar o arquivo pois o usuário não tem acesso à todas as empresas associadas ao(s) veículo(s): ${labels}`,
          }))
          return
        }

        const colunas = [
          [
            'Identificador',
            'Empresa',
            'Nome Fantasia',
            'Cidade',
            'Área',
            'Peso',
            'Caixas',
            'Ordem de Carregamento',
            'Placa',
            'Observação',
          ],
        ]

        fleetsSelected.forEach(f => {
          const { deliveries } = f
          deliveries.forEach(d => {
            colunas.push([
              d.identifier,
              d.company_name,
              d.razao_social,
              d.city,
              d.picking_area,
              d.weight.toFixed(2),
              d.qte_sku,
              d.load_order,
              f.vehicle_badge,
              f.observation,
            ])
          })
        })

        gerarArquivoExcel('Mapa de Carga Analítico', colunas, 'mapa_carga_analitico.xlsx')
      },

      onChangeSelecionarTodos(value) {
        setState(prevState => {
          prevState.selecionarTodos = value
          prevState.fleets = prevState.fleets.map(tp => ({ ...tp, selected: value }))
          return { ...prevState }
        })
      },
    }
  }, [])

  return { state, localDispatch }
}
